import { useEffect } from 'react'

/** Warms the OnboardingContainer chunk while the user is still on signup,
 *  so the Suspense fallback in Router.tsx resolves instantly once they land on /onboarding. */
export const usePreloadOnboardingContainer = (shouldPreload: boolean) => {
    useEffect(() => {
        if (!shouldPreload) return

        import('./OnboardingContainer')
    }, [shouldPreload])
}
